import _get from 'lodash/get';

const getCountryRegion = data => {
  let region;
  switch (_get(data, 'data.continent')) {
    case 'Asia':
    case 'Oceania':
      region = 'APAC';
      break;
    case 'Europe':
    case 'Africa':
      region = 'EMEA';
      break;
    case 'North America':
      region = 'US';
      break;
    case 'South America':
      region = 'SA';
      break;
    default:
      region = 'US';
  }
  return region;
};

export { getCountryRegion };
